<template>
  <div class="about-page">
    <BannerAtom :title="bannerTitle" :image="image" />
    <div>
      <QAMolecule />
    </div>
  </div>
</template>

<script>
import { inject, computed } from 'vue';
import QAMolecule from '../molecules/QAMolecule.vue';
import BannerAtom from '../atoms/BannerAtom.vue';
export default {
  components: {
    QAMolecule,
    BannerAtom,
  },
  setup() {
    const language = inject('language'); // Get the current language context
    const isEnglish = computed(() => language.value === 'en'); // Determine if it's English

    // Define the title based on the language
    const bannerTitle = computed(() => (isEnglish.value ? 'About the Initiative' : 'Om initiativet'));

    return {
      bannerTitle,
      isEnglish,
    };
  },
  data() {
    return {
      image: require('@/assets/images/about.jpg'),
    };
  },
};
</script>

<style scoped>
.about-page {
  background-color: black;
}
</style>
